import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AtmLocations from '@pages/atm-locations/atm-locations';
import salesForce from '@pages/userComponents/menus/salesforce-landing/salesforce-landing-page';
import user from '@pages/userComponents/user';
import CompanyInfoPage from '@pages/userComponents/menus/Company-info/company-info-page';
import ContactInfoPage from '@pages/userComponents/menus/Contact-info/contact-info-page';
import AuthorizedSignatoryPage from '@pages/userComponents/menus/Authorized-Signature/authorized-signatory-page';
import CongratulationPage from '@pages/userComponents/menus/Congratulation page/congratulation-page';
import SummaryPage from '@pages/userComponents/menus/summarypage/summary-page';
import TermsofServiceNew from '@pages/userComponents/menus/summarypage/Components/termsOfService/index';
import SignaturePage from '@pages/userComponents/menus/Signature/signature-page';
import DeliveryCardPage from '@pages/userComponents/menus/Delivery-card page/delivery-card-page';
import AgreementPage from '@pages/userComponents/menus/payroll-agreement/agreement-page';
import Tablecomponent from '@pages/userComponents/menus/Order-cards/employeedetails/employee-detail-functional';

const LoginRoutes = () => {
	return (
		<Switch>
			<Route path="/user" component={user} />
			<Route path="/atmlocations" component={AtmLocations} />
			<Route path="/:optId/:companyName" component={salesForce} />
			<Route path="/tos" component={TermsofServiceNew} />
			<Route path="/employeedetais" component={Tablecomponent} />
		</Switch>
	);
};

const ContactInfoRoutes = () => {
	return (
		<Switch>
			<Route path="/" component={CompanyInfoPage} />
		</Switch>
	);
};

const StepRoutes = () => {
	return (
		<Switch>
			<Route path="/tos" component={TermsofServiceNew} />
			<Route path="/user/companyinfo/:companyId" component={CompanyInfoPage} />
			<Route path="/user/contactinfo/1" component={ContactInfoPage} />
			<Route path="/user/contactinfo/2" component={DeliveryCardPage} />
			<Route path="/user/contactinfo/3" component={SummaryPage} />
			<Route path="/user/signature/1" component={SignaturePage} />
			<Route path="/user/signature/2" component={AgreementPage} />
			<Route path="/user/signature/3" component={AuthorizedSignatoryPage} />
			<Route path="/user/signature/4" component={CongratulationPage} />
		</Switch>
	);
};

const HomeRoutes = () => {
	return (
		<Switch>
			<Route path="/" component={salesForce} exact />
			<Route path="/user" component={user} />
			<Route path="/atmlocations" component={AtmLocations} />
		</Switch>
	);
};

export { LoginRoutes, HomeRoutes, StepRoutes, ContactInfoRoutes };
